import React from 'react';
import { FilterTitle } from './FilterTitle';

export const DesktopFilterTitles = ({ facets, activeFilter, closeModal, openFilterModal }) => (
  <>
    {facets.map((facet) => (
      <FilterTitle
        key={facet.attributeId}
        filter={facet}
        activeFilter={activeFilter}
        closeFilterModal={closeModal}
        openFilterModal={openFilterModal}
      />
    ))}
  </>
);
